import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f589878"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step-controller" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "对换电有疑问", -1))
const _hoisted_3 = { class: "steps-container" }
const _hoisted_4 = { class: "indicator" }
const _hoisted_5 = { class: "title" }

import { HButton } from '@nio-fe/horo-h5'
import { HIconHelp2xs } from '@nio-fe/horo-icons'
import { nioJsBridge } from '@nio-wad/universal-bridge-h5';
import Tracker from '@nio-fe/nio-tracker-web'
import { computed, onMounted, onUnmounted, ref, Teleport, watch } from 'vue'
import type { ImagePreviewProps } from '../components/ImagePreview/ImagePreview.vue'
import ImagePreview from '../components/ImagePreview/ImagePreview.vue'
import { WallMediaListItem } from '../components/ImagePreview/types'

interface SwapDescription {
  question: string
  answer: string
  image?: string
}
interface Props {
  swapDescriptions: SwapDescription[]
}

export default /*#__PURE__*/_defineComponent({
  props: {
    swapDescriptions: null
  },
  setup(__props: any) {

const props = __props as {
  swapDescriptions: SwapDescription[]
}

const mockSwap = (process.config as { [key: string]: any })['mockSwap']
const lastClicked = ref(0)



const ImagePreviewRef = ref<ImagePreviewProps>()

class Step {
  static currentId = 0
  state: 'uninitiated' | 'ongoing' | 'entered' | 'finished'
  id: number
  name: string
  startButtonDescription: string
  constructor(name: string, startButtonDescription: string)
  constructor(id: number, name: string, startButtonDescription: string)
  constructor(nameOrId: number | string, name: string, startButtonDescription?: string) {
    this.state = 'uninitiated'
    if (startButtonDescription !== undefined && name !== undefined) {
      this.name = name
      this.id = nameOrId as number
      this.startButtonDescription = startButtonDescription
    } else {
      this.id = Step.currentId++
      this.name = nameOrId as string
      this.startButtonDescription = name
    }
  }
}

const steps = ref<Step[]>([
  new Step('驶入场站', '开启换电之旅'),
  new Step('自动泊车', '开启自动泊车'),
  new Step('一键换电', '开始换电'),
  new Step('换电完成', '重新开始'),
])
const currentStepIndex = ref(0)
const currentStep = computed<Step>(() => {
  return steps.value[currentStepIndex.value]
})
const startButtonText = computed<string>(() => {
  if (currentStep.value.state === 'ongoing') {
    return '跳过此步'
  } else {
    return currentStep.value.startButtonDescription
  }
})

let reportedTask = false
const reportTask = async () => {
  const urlParams = new URLSearchParams(new URL(window.location.href).search)
  const activityCode = urlParams.get('activity_code')
  console.log('activityCode', activityCode);
  if (activityCode && !reportedTask) {
    // 上报任务
    const arg = {
      scene_code: 'mock_swap',
      biz_data: {
        activity_code: activityCode as string,
      },
      time: new Date().getTime(),
    }
    console.log('====================================')
    console.log('arg', arg)
    await nioJsBridge.invokeAnonymousBridge({
      name: 'welfareTaskRequest',
      data: arg,
      callback: (res) => {
        console.log('universal bridge 模拟换电上报任务结果：', res)
        console.log('====================================')
        if (res.result_code === 'success' && res.data) {
          reportedTask = true
        } else {
          reportedTask = false
        }
      }
    })
  }
}
const goToStep = (index: number) => {
  currentStep.value.state = 'finished'
  currentStepIndex.value = index
  steps.value[index].state = 'entered'
  if (index === 3) {
    reportTask()
  }
}
const CLICK_COOL_DOWN = 1000
const playStep = (index: number) => {
  const now = Date.now()
  if (now - lastClicked.value <= CLICK_COOL_DOWN) {
    return
  } else {
    lastClicked.value = now
  }
  if (index === steps.value.length - 1) {
    restartStep(index)
    return
  }
  if (currentStep.value.state === 'ongoing') {
    // 跳过
    window.postMessageToUnity({
      type: 4103,
      data: {
        currentStep: index,
      },
      mockSwap,
    })
    return
  }
  currentStep.value.state = 'ongoing'
  window.postMessageToUnity({
    type: 4101,
    data: {
      currentStep: index,
    },
    mockSwap,
  })
}
const restartStep = (lastStep: number) => {
  goToStep(0)
  steps.value.forEach((step, index) => {
    if (index !== 0) {
      step.state = 'uninitiated'
    }
  })
  window.postMessageToUnity({
    type: 4101,
    data: {
      currentStep: lastStep,
    },
    mockSwap,
  })
}

goToStep(0)

function messageHandler(ev: Event) {
  switch (ev?.data?.type) {
    // 动画播放完成
    case 4102: {
      const targetStep = ev.data?.data?.currentStep
      goToStep(currentStep.value.id + 1)
    }
  }
}

const $swipe = ref()
const swipeTo = (index: number) => {
  $swipe.value.swipeTo(index)
}

const descriptionExpanded = ref(false)
const swapDescriptions = ref<WallMediaListItem[]>([
  {
    title: '我的新车电池会换成旧电池吗？',
    title_desc:
      '电池本质上是存储电量的单位，不分新旧，只分健康或者不健康。蔚来换电站里的每块电池都符合健康标准，每次换电都会对电池进行检测。',
  },
  {
    title: '开电车跑长途怎么办？',
    title_desc:
      '除了在城区布局换电站，蔚来在高速服务区已经建成XX座高速换电站。蔚来换电站还支持短租大电池。75度电池升级100度，日租只要50块。',
  },
  {
    title: '换电一定很贵吧？',
    title_desc: '换一次电，50-80元左右，比充电还便宜。只有加油费用的1/6',
  },
  {
    title: '我家附近有吗，没有怎么办？',
    title_desc: '超过78%的蔚来车主，家或者公司3km范围内有蔚来换电站',
  },
  {
    title: '蔚来有多少换电站，什么概念？',
    title_desc:
      '截止当前，蔚来一共有XX座换电站，全国麦当劳门店5500座，相当于每2家麦当劳就有1座蔚来换电站',
  },
])
watch(
  () => props.swapDescriptions,
  (newValue) => {
    if (newValue && newValue.length > 0) {
      swapDescriptions.value = newValue.map((item) => {
        return {
          title: item.question,
          title_desc: item.answer,
          pop_up_image: item.image,
        } as WallMediaListItem
      })
    }
  },
  {
    immediate: true,
  }
)

function onExpandClick() {
  descriptionExpanded.value = !descriptionExpanded.value
  const urlParams = new URLSearchParams(window.location.href)
  Tracker.track('mockswaph5_aboutpssclick', {
    refer_page: urlParams.get('from'),
  })

  if (swapDescriptions.value) {
    ImagePreviewRef?.value?.show(swapDescriptions.value, 0)
  }
}

const hasHide = () => {
  descriptionExpanded.value = false
}

onMounted(() => {
  window.addEventListener('unitymessage', messageHandler)
})

onUnmounted(() => {
  window.removeEventListener('unitymessage', messageHandler)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "help",
      onClick: onExpandClick
    }, [
      _createVNode(_unref(HIconHelp2xs), { size: "14" }),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['step', step.state]),
          key: step.id
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(index + 1), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(step.name), 1)
        ], 2))
      }), 128))
    ]),
    _createVNode(_unref(HButton), {
      class: _normalizeClass(['next-step', _unref(currentStep).state === 'ongoing' ? 'skip' : '']),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (playStep(_unref(currentStep).id))),
      round: "",
      block: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(startButtonText)), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      _createVNode(ImagePreview, {
        ref_key: "ImagePreviewRef",
        ref: ImagePreviewRef,
        onHasHide: hasHide
      }, null, 512)
    ]))
  ]))
}
}

})